function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { parseQueryParams } from 'shared/helper/link-helper';
import { convertJsonToSelectFieldValue } from './generics-conversion-service';
export var convertJsonToUserInformationFormData = function convertJsonToUserInformationFormData(json, _ref) {
  var _json$phoneVerified;
  var isoCode = _ref.currentLocalization.isoCode,
    currencies = _ref.currencies,
    countries = _ref.countries,
    foundUsOptions = _ref.foundUsOptions;
  var currency = currencies.find(function (c) {
    return c.value === json.currencyIso;
  }) || {
    value: null
  };
  var language = {
    value: json.language
  };
  var country = isoCode ? countries.find(function (country) {
    return country.isoCode === isoCode;
  }) : countries.find(function (country) {
    return country.value === json.countryId;
  });
  var foundUs = '';
  var otherFoundUs = '';
  if (json.foundUs) {
    var foundUsOption = foundUsOptions.find(function (fuo) {
      return fuo === json.foundUs;
    });
    foundUs = {
      value: foundUsOption || 'Other Website',
      label: foundUsOption || 'Other Website'
    };
    // If we get here, it was data entered in the other found us field
    if (!foundUsOption) {
      otherFoundUs = json.foundUs;
    }
  }
  var groupCode = json.preferredGroup ? {
    label: json.preferredGroup.code,
    value: json.preferredGroup.code
  } : '';
  return {
    active: json.active,
    addedToWatchlist: !!json.watchlistNotification,
    agreeToTOS: false,
    // Default
    companySelection: {
      value: json.companyId || null
    },
    confirmEmail: json.email,
    country: country || null,
    creditNotesLocked: json.creditNotesLocked,
    currency: currency,
    currencySelectionDisabled: currency !== null && currency.value !== null,
    email: json.email,
    excludeFromDelinquentCheck: json.excludeFromDelinquentCheck,
    firstName: json.firstName,
    foundUs: foundUs,
    groupCode: groupCode,
    language: language,
    lastName: json.lastName,
    orcid: json.orcid || '',
    origin: json.origin || '',
    otherFoundUs: otherFoundUs,
    overrideDownloadAvailable: json.overrideDownloadAvailable,
    phoneNumber: json.phoneNumber || '',
    phoneVerified: (_json$phoneVerified = json.phoneVerified) !== null && _json$phoneVerified !== void 0 ? _json$phoneVerified : false,
    secondaryEmail: json.secondaryEmail || '',
    showCheckSpamMessage: json.showCheckSpamMessage,
    title: {
      value: json.title,
      label: json.title
    },
    watchlistNotification: json.watchlistNotification
  };
};
export var convertJsonToInstitutionInformationFormData = function convertJsonToInstitutionInformationFormData(json) {
  return {
    city: json.city,
    institution: {
      institution: json.institution.identity ? convertJsonToSelectFieldValue(json.institution.identity, {
        label: json.institution.name
      }) : convertJsonToSelectFieldValue(json.institution.name),
      type: convertJsonToSelectFieldValue(json.institution.type),
      position: convertJsonToSelectFieldValue(json.institution.position)
    }
  };
};
var populateInstitution = function populateInstitution(institutionData) {
  var institution = {};
  if (institutionData.institution) {
    var _institutionData$inst, _institutionData$inst2;
    institution.identity = (_institutionData$inst = institutionData.institution.identity) !== null && _institutionData$inst !== void 0 ? _institutionData$inst : '';
    institution.name = (_institutionData$inst2 = institutionData.institution.label) !== null && _institutionData$inst2 !== void 0 ? _institutionData$inst2 : '';
  }
  if (institutionData.position) {
    var _institutionData$posi;
    institution.position = (_institutionData$posi = institutionData.position.value) !== null && _institutionData$posi !== void 0 ? _institutionData$posi : '';
  }
  if (institutionData.type) {
    var _institutionData$type;
    institution.type = (_institutionData$type = institutionData.type.value) !== null && _institutionData$type !== void 0 ? _institutionData$type : '';
  }
  return institution;
};
export var convertFormDataToInstitutionInformationUpdateRequest = function convertFormDataToInstitutionInformationUpdateRequest(formData) {
  var userDetails = {
    city: formData.city
  };
  if (formData.institution) {
    userDetails.institution = populateInstitution(formData.institution);
  }
  return {
    userDetails: userDetails
  };
};
export var convertFormDataToUserUpdateRequest = function convertFormDataToUserUpdateRequest(formData, _ref2) {
  var _window, _URLSearchParams$get, _formData$title$value, _formData$title, _formData$groupCode, _formData$companySele, _formData$foundUs;
  var languages = _ref2.languages;
  var country = {
    id: formData.country.value
  };
  var userTags = [];
  var currentUrl = (_window = window) === null || _window === void 0 || (_window = _window.location) === null || _window === void 0 ? void 0 : _window.href;
  var isRubriqHost = window.location.hostname.includes('rubriq');
  if ((formData === null || formData === void 0 ? void 0 : formData.origin) === 'curie' || parseQueryParams(window.location.search).origin === 'curie' || (_URLSearchParams$get = new URLSearchParams(window.location.search).get('redirect')) !== null && _URLSearchParams$get !== void 0 && _URLSearchParams$get.includes('?origin=curie') || isRubriqHost) {
    userTags.push({
      tagName: 'curie_brand_customer',
      tagValue: '1'
    }, {
      tagName: 'curie_interested_customer',
      tagValue: '1'
    }, {
      tagName: 'curie_registered_customer',
      tagValue: '1'
    });
  } else if (currentUrl.includes('grammar-check')) {
    userTags.push({
      tagName: 'aje_registered_customer',
      tagValue: '1'
    }, {
      tagName: 'grammar_check_registered_customer',
      tagValue: '1'
    });
  } else if (currentUrl.includes('word-addin')) {
    userTags.push({
      tagName: 'rubriq_wordaddin_interested_customer',
      tagValue: '1'
    });
  } else {
    userTags.push({
      tagName: 'aje_registered_customer',
      tagValue: '1'
    });
  }
  var userDetails = {
    // Account details
    title: (_formData$title$value = formData === null || formData === void 0 || (_formData$title = formData.title) === null || _formData$title === void 0 ? void 0 : _formData$title.value) !== null && _formData$title$value !== void 0 ? _formData$title$value : '',
    firstName: formData.firstName,
    lastName: formData.lastName,
    email: formData.email,
    secondaryEmail: formData.secondaryEmail,
    phoneNumber: formData.phoneNumber,
    country: country,
    language: formData.language.value || languages[0].isoCode,
    currencyIso: formData.currency.value,
    orcid: (formData.orcid || '').replace(/https:\/\/orcid.org\//, ''),
    // Admin account details
    preferredGroupCode: ((_formData$groupCode = formData.groupCode) === null || _formData$groupCode === void 0 ? void 0 : _formData$groupCode.value) || '',
    active: !!formData.active,
    excludeFromDelinquentCheck: formData.excludeFromDelinquentCheck,
    showCheckSpamMessage: formData.showCheckSpamMessage,
    overrideDownloadAvailable: formData.overrideDownloadAvailable,
    creditNotesLocked: !!formData.creditNotesLocked,
    watchlistNotification: formData.addedToWatchlist && formData.watchlistNotification ? formData.watchlistNotification : '',
    // Admin user creation details
    companyId: (formData === null || formData === void 0 || (_formData$companySele = formData.companySelection) === null || _formData$companySele === void 0 ? void 0 : _formData$companySele.value) || '',
    localization: formData.localization || '',
    // Registration details
    foundUs: (formData === null || formData === void 0 || (_formData$foundUs = formData.foundUs) === null || _formData$foundUs === void 0 ? void 0 : _formData$foundUs.value) || '',
    otherFoundUs: formData.otherFoundUs,
    password: formData.password || '',
    optinToMarketing: !!formData.optinToMarketing,
    // Curie tag
    userTags: userTags,
    institution: formData.institution ? populateInstitution(formData.institution) : undefined,
    phoneVerified: formData.phoneVerified
  };
  return {
    userDetails: userDetails
  };
};
export var convertUserDataToUserUpdateRequest = function convertUserDataToUserUpdateRequest(user, currencyIso) {
  var country = {
    countryId: user.countryId,
    country: user.country
  };
  var institution = {
    identity: user.institution.identity,
    name: user.institution.name,
    position: user.institution.position,
    type: user.institution.type
  };
  // Account details
  var userDetails = {
    title: user.title,
    firstName: user.firstName,
    lastName: user.lastName,
    email: user.email,
    secondaryEmail: user.secondaryEmail,
    phoneNumber: user.phoneNumber,
    country: country,
    institution: institution,
    language: user.language,
    currencyIso: currencyIso,
    orcid: user.orcid,
    // Registration details
    foundUs: user.foundUs
  };
  return {
    userDetails: userDetails
  };
};
export var convertUserDetailsToJson = function convertUserDetailsToJson(userDetails) {
  return _objectSpread(_objectSpread({}, userDetails), {}, {
    addresses: userDetails.addresses,
    missingFields: userDetails.missingFields
  });
};